import { type RcFile } from 'antd/es/upload'

import { DESCRIPTIONS } from '@/constants/common/message.constants'

const CSV_EXTENSION = '.csv'
const CSV_VALID_MIME_TYPES = [
  'text/csv',
  'application/vnd.ms-excel',
  'text/plain',
  'text/x-csv',
  'application/csv',
  'application/x-csv'
]

const XLSX_EXTENSION = '.xlsx'
const XLSX_VALID_MIME_TYPE =
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'

export const validateCsvFile = (file: RcFile): string | null => {
  if (file.name.toLowerCase().endsWith(CSV_EXTENSION)) {
    return null
  }

  if (CSV_VALID_MIME_TYPES.includes(file.type)) {
    return null
  }

  return DESCRIPTIONS.ONLY_CSV_FILE_CAN_BE_UPLOADED(file.type)
}

export const validateExcelFile = (file: RcFile): string | null => {
  if (file.name.toLowerCase().endsWith(XLSX_EXTENSION)) {
    return null
  }
  if (file.type === XLSX_VALID_MIME_TYPE) {
    return null
  }

  return DESCRIPTIONS.ONLY_EXCEL_FILE_CAN_BE_UPLOADED(file.type)
}
